function Contact() {
  return (
    <section id="contact" className="divider grid-bg">
      <div className="wrap contact">
        <h2>Let's build something precise.</h2>
        <p>
          Open to frontend and full-stack roles, collaborations, and
          conversations about React, TypeScript, or where the two of us might
          already know people in common in Toronto tech.
        </p>
        <div className="contact-links">
          <a
            className="btn amber"
            href="mailto:shreyanshkoladiyawork@gmail.com"
          >
            Email me
          </a>
          <a
            className="btn ghost"
            href="https://github.com/shreyu1701"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          <a
            className="btn ghost"
            href="https://www.linkedin.com/in/shreyanshkoladiya/"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
